// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_87-0";
export var optionCard = "_87-1";